import React, { createContext, useContext, useEffect, useState } from "react";
import { authService } from "../services/api";
import { useUser } from "./UserContext";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const { setUser } = useUser();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const u = await authService.getCurrentUser();
        if (mounted) setUser(u);
      } catch (e) {
        if (mounted) setUser(null);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => (mounted = false);
  }, [setUser]);

  // Set up periodic token refresh (every 14 minutes)
  useEffect(() => {
    const refreshInterval = setInterval(async () => {
      try {
        await authService.refreshToken();
        console.log("Token automatically refreshed");
      } catch (error) {
        console.error("Automatic token refresh failed:", error);
        // Don't force logout here - let the next API call handle it
      }
    }, 14 * 60 * 1000);

    return () => clearInterval(refreshInterval);
  }, []);

  const login = async (redirectPath) => {
    try {
      if (redirectPath) {
        sessionStorage.setItem("postLoginRedirect", redirectPath);
        localStorage.setItem("postLoginRedirect", redirectPath);
      }
    } catch (_) {}
    const data = await authService.getAuthorizationUrl(redirectPath);
    console.log("Auth data:", data);
    const authorizationUrl =
      data?.authorizationUrl || data?.authorization_url || data?.url;
    console.log("Authorization URL:", authorizationUrl);
    if (authorizationUrl) {
      window.location.href = authorizationUrl;
    }
  };

  const refresh = async () => {
    await authService.refreshToken();
    const u = await authService.getCurrentUser();
    setUser(u);
  };

  const logout = async () => {
    await authService.logout();
    setUser(null);
    try {
      sessionStorage.removeItem('postLoginRedirect');
      sessionStorage.removeItem('postLoginRedirectUsed');
      localStorage.removeItem('postLoginRedirect');
      localStorage.removeItem('postLoginRedirectUsed');
    } catch (_) {}
    // Stay on current page after logout instead of redirecting to OIDC
    // User will be prompted to login again if they try to access protected routes
  };

  return (
    <AuthContext.Provider value={{ loading, login, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}